/* 🤖 this file was generated by svg-to-ts */
export const DfIconEyeClosed12: {
  name: 'eye-closed-12';
  data: string;
} = {
  name: 'eye-closed-12',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><path d="M2.72.6a.75.75 0 0 0-.275 1.025l.495.857c-.834.555-1.651 1.343-2.454 2.364l-.182.235-.075.11a1.5 1.5 0 0 0 .075 1.702C2.12 9.29 4.015 10.487 5.99 10.487c.486 0 .968-.072 1.446-.218l.492.852a.75.75 0 0 0 1.299-.75L3.744.875A.75.75 0 0 0 2.719.601zm3.934 8.316-.83-1.44a1.5 1.5 0 0 1-1.201-2.079l-.832-1.44a3 3 0 0 0 2.863 4.959z" fill-rule="evenodd"/><path d="M11.507 7.133a12.791 12.791 0 0 1-1.492 1.605L8.891 6.79A3.003 3.003 0 0 0 6.75 3.08l-.92-1.59.16-.003c1.973 0 3.873 1.197 5.7 3.59a1.5 1.5 0 0 1 .073 1.718l-.073.103z"/></svg>`
};
